import { Validation } from '@bepro-travel/fe.utils';

export const blobUrl = 'https://ru.ophirtours.co.il/backend/s3/prod.beprotravel/cdn/';
export const cdnUrl = 'https://ru.ophirtours.co.il';
export const blobPath = '/backend';

export const baseUrl = 'https://ru.ophirtours.co.il/backend';
export const reCaptchaKey = '6Lcxn8gqAAAAADjPe8e--Zne7dV2v1n7CJNNSX4m';

export const contactUsValidation: Validation = {
  firstName: { required: true, maxLength: 30 },
  phone: { required: true, numbers: true, length: 10 },
  email: { required: true, email: true },
  message: { required: true },
};

export const imgBg = require('./assets/img/newbg_flights.jpg');
export const soldOutImg = require('./assets/img/sold_out.png');
export const roomsCountSelect = [
  { value: 0, label: 'room.choose' },
  { value: 1, label: 'room.c1' },
  { value: 2, label: 'room.c2' },
  { value: 3, label: 'room.c3' },
  { value: 4, label: 'room.c4' },
  { value: 5, label: 'room.c5' },
  { value: 6, label: 'room.c6' },
  { value: 7, label: 'room.c7' },
  { value: 8, label: 'room.c8' },
  { value: 9, label: 'room.c9' },
];

export const sharedConfig = {
  setUser: () => { },
  setHeader: () => { },
  setProposals: () => { },
  setFooter: () => { },
  setSiteConfig: () => { },
  setLanguage: () => { },
  SliderSearch: () => <></>,
  ProposalModal: () => <></>,
  SearchBox: () => <></>,
  imgUs: '',
  imgIs: '',
  imgBg: '',
  imgLogo: '',
  imgPaymentLoader: '',
  language: '',
  proposals: [],
  cdnUrl: '',
  defaultMultiSearchConfig: '',
};

export const cssForPrint = `
<style>
  /* Variables (literal values for isolated print document) */
  :root {
    --color-100: #f9fafb;
    --color-150: #efefef;
    --color-200: #ddd;
    --color-300: #a49f9f;
    --color-400: #666;
    --color-500: #333;
    --color-text: #666;
    --color-text-light: #a49f9f;
    --color-border: #efefef;
    --border-radius-md: 12px;
  }

  * { box-sizing: border-box; }
  body { margin: 0; padding: 0; color: var(--color-text); font-size: 1rem; }\

  svg {
  width: 20px;
  height: 20px;
  }

  /* Utilities */
  .mb-20 { margin-bottom: 20px; }
  .mb-10 { margin-bottom: 10px; }
  .display-flex { display: flex; align-items: center; }
  .text-md { font-size: 1rem; }
  .text-lg { font-size: 1.125rem; padding: 15px; }
  .text-bold { font-weight: 700; }
  .title {margin-bottom: 10px;}

  /* ========== Block 1: #oph-details-first (carousel + summary) ========== */
  #oph-details-first.oph-details-first,
  .oph-details-first {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    flex-direction: column;
  }

  .oph-details-center {
    flex: 0 1 calc(100% - 320px);
    border-radius: var(--border-radius-md);
    overflow: hidden;
    background: #fff;
    margin-bottom: 20px;
    width: 100%;
  }
  .oph-details-center .text-lg { padding: 15px; }
  .oph-details-center .name { font-weight: 700; }
  .oph-details-slider {
    height: 500px;
    position: relative;
    overflow: hidden;
  }
  .oph-details-slider img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
  .oph-details-slider .slick-slider,
  .oph-details-slider .slick-list,
  .oph-details-slider .slick-track { height: 100%; }
  .oph-details-slider .slick-slide > div { height: 100%; }
  .oph-details-slider .slick-dots,
  .oph-details-slider .slick-prev,
  .oph-details-slider .slick-next { display: none !important; }

  .oph-details-sidebar {
    flex: 0 0 100%;
    display: flex;
    flex-direction: column;
    padding: 10px 15px;
    background: #fff;
    width: 100%;
  }
  .oph-details-sidebar .title {
    border-bottom: 1px solid var(--color-200);
    padding-bottom: 10px;
    margin-top: 0;
    font-weight: 600;
    
  }
  .oph-details-sidebar svg { padding-inline-end: 5px; }

  /* ========== Block 2: #oph-details-flight ========== */

    #oph-details-flight {
     page-break-inside: avoid;
      margin-bottom: 20px;
    }

  .oph-ticket {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 20px;
    padding-bottom: 20px;
    background: #fff;
  }
    .oph-ticket.default-shadow {
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    page-break-inside: avoid;
    }
  .oph-ticket-header {
    display: flex;
    width: 100%;
    padding: 10px 15px;
    border-bottom: 1px solid var(--color-100);
    margin-bottom: 10px;
    align-items: center;
  }
  .oph-ticket-header svg { margin-right: 10px; width: 20px; }
  .oph-ticket-logo {
    flex: 0 0 125px;
    flex-direction: column;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 20px;
    margin-left: 20px;
  }
  .oph-ticket-logo img { display: block; width: 100%; max-width: 110px; }
  .oph-ticket-logo .name { font-size: 13px; color: var(--color-text-light); }
  .oph-ticket-route {
    display: flex;
    flex-direction: column;
    color: var(--color-text);
    align-items: center;
    flex: 0 0 30%;
    padding: 10px 0 25px;
    text-align: center;
  }
  .oph-ticket-route .city { font-size: 15px; margin-bottom: 5px; }
  .oph-ticket-route .city .code { font-size: 13px; }
  .oph-ticket-route .time { font-size: 1.25rem; font-weight: 500; }
  .oph-ticket-route .date { font-size: 10px; }
  .oph-ticket-separator {
    flex: 0 0 16%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
    color: var(--color-text-light);
  }
  .oph-ticket-separator::after {
    content: '';
    border-top: 1px dashed var(--color-text-light);
    left: 0;
    right: 0;
    top: 50%;
    position: absolute;
  }
  .oph-ticket-separator .circle {
    border-radius: 50%;
    height: 6px;
    width: 6px;
    background-color: var(--color-text-light);
    position: relative;
    z-index: 1;
  }
  .oph-ticket-separator .type-flight {
    font-size: 10px;
    margin-bottom: 5px;
    text-align: center;
    top: 24%;
    left: 0;
    right: 0;
    position: absolute;
  }
  .oph-ticket-separator svg { position: relative; z-index: 1; }

  /* ========== Block 3: #oph-include (include card) ========== */
  #oph-include {
  margin-bottom: 30px;
  }
  #oph-include .title {
    font-weight: 600;
    margin-bottom: 15px;
    font-size: 1.125rem;
  }
  #oph-include .default-shadow {
    background: #fff;
    padding: 0;
  }

  .include-wr {
    padding: 10px 15px;
  }
  .include-wr .title {
    border-bottom: 1px solid var(--color-200);
    font-weight: 500;
    display: block;
    padding: 0 0 10px;
    margin-bottom: 5px;
  }
  .include-wr .item {
    padding: 5px 0;
    display: flex;
    line-height: 1.4;
    align-items: flex-start;
  }
  .include-wr svg {
    position: relative;
    top: 4px;
    margin-right: 10px;
    flex-shrink: 0;
  }
  .include-wr .include svg { color: green; }
  .include-wr .no-include svg { color: red; }
  .include-wr .info svg { color: #0b9be5; }
</style>
`;